<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" viewBox="0 0 32 32" x="0px" y="0px">
    <path
      d="M28.55,8.17l-6-4a1,1,0,0,0-1.1,0L16,7.8,10.55,4.17a1,1,0,0,0-1.1,0l-6,4A1,1,0,0,0,3,9V27a1,1,0,0,0,.53.88,1,1,0,0,0,1-.05L10,24.2l5.45,3.63a1,1,0,0,0,1.1,0L22,24.2l5.45,3.63A1,1,0,0,0,29,27V9A1,1,0,0,0,28.55,8.17Zm-18,14A1,1,0,0,0,10,22V6.2l5.45,3.63A1,1,0,0,0,16,10V25.8Zm16.45,3-4.45-3A1,1,0,0,0,22,22V6.2l5,3.34Z"
    />
  </svg>
</template>
